package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.toScaleDp

@Composable
fun DetailsContainerContact(content: @Composable () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(color = Color(0xfffcfcfc))
            .padding(horizontal = 75.toScaleDp(), vertical = 15.toScaleDp())
            .requiredHeight(height = 773.toScaleDp())
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .border(
                    width = 1.toScaleDp(),
                    color = BorderColor,
                    shape = boxCornerShape()
                )
                .background(color = Color.White, shape = boxCornerShape())
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.Top,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                content()
            }
        }
    }
}